module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon21.68b7e83f.png";